import { Config } from "@blacknut/javascript-sdk/dist";
export const startSpeedtest = (config: Config) => {
  // web
  if (window.Worker && process.env.NODE_ENV !== "test") {
    import("./SpeedTestWebWorkerService").then((e) => e.default.start(config));
    return;
  }
  import("./SpeedTestWebService").then((e) => e.default.start(config));
  return;
};

export const runSpeedtest = (config: Config) => {
  // web
  if (window.Worker && process.env.NODE_ENV !== "test") {
    import("./SpeedTestWebWorkerService").then((e) => e.default.run(config));
    return;
  }
  import("./SpeedTestWebService").then((e) => e.default.run(config));
  return;
};
